
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {LibraryLayout} from '../../components/Library'

export const metadata = {
  "title": "MAY21 Launch Lineup",
  "date": "2021-05-05",
  "author": "The Hyperlink Team",
  "toc": true,
  "living": false,
  "tags": ["announcement"],
  "description": "May Knowledge Drop: new month, new learning!",
  "topic": ""
};

const layoutProps = {
  metadata
};
const MDXLayout = ({children}) => <LibraryLayout {...metadata}>{children}</LibraryLayout>
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`It's time for Hyperlink's monthly launch — or `}<strong parentName="p">{`knowledge drop`}</strong>{` — with some great cohorts now open for enrollment!`}</p>
    <p><em parentName="p">{`interface design ✨ graphical systems ✨ I Ching ✨ journaling practice ✨ creator websites ✨ personal cinema ✨ archiving ✨ at-home ecology ✨ conservation ✨ art of memory ✨ autodidacticism`}</em></p>
    <p>{`Click each to learn more and enroll. (Ones labeled "NEW" = starting their very first cohort!)`}</p>
    <h2 {...{
      "id": "courses"
    }}>{`Courses`}</h2>
    <h3 {...{
      "id": "gender-in-digital-interfaces---new-"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/courses/gender-in-digital-interfaces/103/cohorts/131"
      }}>{`Gender in Digital Interfaces`}</a>{` - NEW 🌱✨`}</h3>
    <p>{`Explore cultural notions about gender as they apply to design and technology, in order to imagine more exciting and equitable futures!`}</p>
    <p>{`Starts May 5, $240, 6 weeks`}</p>
    <h3 {...{
      "id": "graphic-catalysis---new-"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/courses/graphic-catalysis/104/cohorts/128"
      }}>{`Graphic Catalysis`}</a>{` - NEW 🌱✨`}</h3>
    <p>{`In this course we will examine our personal creative practices and use a systems-based approach to explore, generate, and document new transformative procedures using Photoshop and web apps.`}</p>
    <p>{`Starts May 10, $200, 6 weeks`}</p>
    <h3 {...{
      "id": "i-ching-as-a-tool-for-thought---new-"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/courses/i-ching-as-a-tool-for-thought/117/cohorts/136"
      }}>{`I Ching as a Tool for Thought`}</a>{` - NEW 🌱✨`}</h3>
    <p>{`Learn about tools for thought, the I Ching, and how to bring the two together in an I Ching consultation practice to explore interpretation, uncertainty, problem-solving and more.`}</p>
    <p>{`Starts May 13, $150, 4 weeks`}</p>
    <h3 {...{
      "id": "journaling-for-the-long-haul---new-"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/courses/journaling-for-the-long-haul/84/cohorts/137"
      }}>{`Journaling for the Long Haul`}</a>{` - NEW 🌱✨`}</h3>
    <p>{`This class will guide you through creating a journaling practice that works for you by identifying your goals, introducing you to inspiration, and setting up a habit.`}</p>
    <p>{`Starts May 24, $150, 5 weeks`}</p>
    <h3 {...{
      "id": "websites-for-creatives---new-"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/courses/websites-for-creatives/66/cohorts/138"
      }}>{`Websites for Creatives`}</a>{` - NEW 🌱✨`}</h3>
    <p>{`Giving creatives/artists the tools and understanding to design and code their own site that’s centered around a creative endeavor. Handling website craft as an art, and a form of gardening.`}</p>
    <p>{`Starts May 27, $360, 9 weeks`}</p>
    <h3 {...{
      "id": "personal-cinema-by-way-of-beginners-mind---new-"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/courses/personal-cinema-by-way-of-beginners-mind/100/cohorts/141"
      }}>{`Personal Cinema by Way of Beginner's Mind`}</a>{` - NEW 🌱✨`}</h3>
    <p>{`"We do not tell stories as they are," Anaïs Nin wrote, "We tell stories as we are." Develop your creative voice by utilizing the Beginner's Mind technique to make short home movies.`}</p>
    <p>{`Starts June 1, $195, 5 weeks`}</p>
    <h3 {...{
      "id": "archiving-as-a-creative-practice---new-"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/courses/archiving-as-a-creative-practice/121"
      }}>{`Archiving as a Creative Practice`}</a>{` - NEW 🌱✨`}</h3>
    <p>{`An introduction to “casual” archiving, focused on developing personal methodologies that allow us to engage on a more intimate level with found and historic materials.`}</p>
    <p>{`Starts June 7, $225, 5 weeks`}</p>
    <p><strong parentName="p">{`SOLD OUT!`}</strong>{` — if you're interested you can a) watch on the course page to get updates on future cohorts, and b) ask `}<a parentName="p" {...{
        "href": "https://twitter.com/domesticetch"
      }}>{`Elizabeth`}</a>{` about the archiving Slack group she's starting :)`}</p>
    <h3 {...{
      "id": "fantastic-beasts-for-the-home-and-garden---new-"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/courses/fantastic-beasts-for-the-home-and-garden/119/cohorts/139"
      }}>{`Fantastic Beasts for the Home and Garden`}</a>{` - NEW 🌱✨`}</h3>
    <p>{`Cultivate animal familiars, plant companions, and fungal allies in this project-based course on intimacy, ecology, and what it means to be human in the post-anthropocene.`}</p>
    <p>{`Starts June 13, $200, 4 weeks`}</p>
    <h3 {...{
      "id": "the-home-collection-game"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/courses/the-home-collection-game/64/cohorts/85"
      }}>{`The Home Collection Game`}</a></h3>
    <p>{`Roleplay as secret agents and supervillains as you learn to apply museum knowledge on preventive conservation and create tailored preservation measures for your own home collections.`}</p>
    <p>{`Starts June 26, $200, 5 weeks`}</p>
    <h3 {...{
      "id": "art-of-memory---new-"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/courses/art-of-memory/122/cohorts/140"
      }}>{`Art of Memory`}</a>{` - NEW 🌱✨`}</h3>
    <p>{`We'll rediscover, explore, and practice several ancient memory techniques to dramatically improve and expand our ability to memorize a vast array of knowledge.`}</p>
    <p>{`Starts July 10, $225, 5 weeks`}</p>
    <h2 {...{
      "id": "clubs"
    }}>{`Clubs`}</h2>
    <h3 {...{
      "id": "house-of-interdisciplinary-autodidacts---new-"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/courses/house-of-interdisciplinary-autodidacts/42/cohorts/35"
      }}>{`House of Interdisciplinary Autodidacts`}</a>{` - NEW 🌱✨`}</h3>
    <p>{`Join fellow autodidacts to explore intriguing interdisciplinary questions together and to learn the secrets of leveraging the web for more professional autonomy and free-agency.`}</p>
    <p>{`Starts May 15, $40, 5 weeks`}</p>
    <h2 {...{
      "id": "get-involved"
    }}>{`Get Involved`}</h2>
    <p>{`As always, we're excited to see anything you have in mind for a course or club — you can share here: `}<a parentName="p" {...{
        "href": "https://hyperlink.academy/forms/propose-course"
      }}>{`propose a course`}</a>{` or `}<a parentName="p" {...{
        "href": "https://hyperlink.academy/forms/propose-club"
      }}>{`propose a club`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://hyperlink.academy/create"
      }}>{`Learn more about creating learning experiences with Hyperlink`}</a>{`.`}</p>
    <p>{`Other ideas for experiments we should try? We'd love to `}<a parentName="p" {...{
        "href": "mailto:contact@hyperlink.academy"
      }}>{`hear from you`}</a>{`!`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;